import { Emmit, HeightAnim_2 } from './utils';

/**
 * Change current products with filtered products
 *
 * @param response
 * @param output
 * @param btn
 */
function renderProducts( response, { output, btn } ) {
	const modal                    = document.querySelector( '#sidebar-filters' ),
	      selected_checks          = modal.querySelectorAll( 'input:checked' ),
	      filter_openner_btn_count = modal.previousElementSibling.querySelector( '.filters-count' );

	modal && modal.classList.remove( 'show' );
	filter_openner_btn_count.textContent = `(${ selected_checks.length })`;

	// Reset load more pages
	if ( btn ) {
		btn.dataset.page  = '2';
		btn.style.display = response.last_page ? 'none' : 'inline-grid';
	}

	output.innerHTML = response.data.reduce( ( acc, product ) => acc + product, '' );
}

/**
 * Append new product cards to div
 *
 * @param response
 * @param output
 * @param btn
 */
function renderProductsMore( response, { output, btn } ) {
	btn.dataset.page  = +btn.dataset.page + 1;
	btn.style.display = response.last_page ? 'none' : 'inline-grid';

	output.insertAdjacentHTML( 'beforeend', response.data.reduce( ( acc, product ) => acc + product, '' ) );
}

/**
 * Object with parameters
 * {parameter_name: parameter_value, parameter_name_2: parameter_value_2}
 * @param params
 * @returns {string}
 */
function composeParameters( params = {} ) {
	return Object.entries( params ).map( parameter => {
		return `${ parameter[ 0 ] }=${ parameter[ 1 ] }&`;
	} ).join( '' );
}

/**
 *
 * @param inputs
 * @returns [string, [array]]
 */
function getInputCheckValues( inputs ) {
	const obj = {};

	[ ...inputs ].filter( input => input.checked ).forEach( input => {
		if ( obj[ input.name ] ) {
			obj[ input.name ].push( input.value );
		} else {
			obj[ input.name ] = [ input.value ];
		}
	} );

	// Remove parent taxonomy if it's child is selected
	inputs.forEach( input => {
		const input_index = obj[ input.name ].indexOf( input.dataset.parent );

		if ( input_index > -1 ) {
			obj[ input.name ].splice( input_index, 1 );
		}
	} );


	return Object.entries( obj );
}

/**
 * Load posts from REST API
 *
 * @param url
 * @param parameters
 * @param type
 * @param callback
 * @param callbackParams
 * @param errorCallback
 */
function loadPosts( url, parameters, type = 'fetch', callback = false, callbackParams = {}, errorCallback = false ) {
	// Emmit event for fetch start
	new Emmit( '', { type: `${ type }.started` } );

	fetch( `${ url }?${ parameters }` )
		.then( res => res.json() )
		.then( data => {
			// Emmit event for fetch end
			new Emmit( '', { type: `${ type }.finished` } );

			// Check if there has been an error in backend
			if ( data.error ) {
				// If there is error callback call it
				if ( errorCallback && typeof errorCallback === 'function' ) {
					// Compose posts layout
					errorCallback( data.error );
				}

				console.error( 'Dogodila se greška: ', data.error );
				return;
			}

			if ( callback && typeof callback === 'function' ) {
				// Compose posts layout
				callback( data, callbackParams );
			}

		} )
		.catch( error => {
			// Emmit event for fetch error
			new Emmit( '', { type: `${ type }.error` } );
			new Emmit( '', { type: `${ type }.finished` } );

			console.error( error );
		} );
}

/**
 * Remove applied filter when clicked on button indicator
 *
 * @param btn_to_remove {Element}
 * @param isInput {boolean}
 */
function handleRemoveFilter( btn_to_remove, isInput = false ) {
	const corresponding_item = document.querySelector( isInput ? `#indicator-${ btn_to_remove.id }` : btn_to_remove.dataset.input );

	// Check if item exists
	if ( !corresponding_item ) {
		return;
	}

	// If it is input provided, then invoke click on corresponding button that will recall this function and then uncheck input
	if ( isInput ) {
		corresponding_item.click();
		return;
	}

	// Uncheck input
	corresponding_item.checked = false;
	// Emmit change event
	new Emmit( corresponding_item, { type: 'change' } );
	// Remove button indicator
	btn_to_remove.remove();
}

window.addEventListener( 'load', () => {
	const filters   = document.querySelector( '.sidebar--shop' ),
	      output    = document.querySelector( '.products' ),
	      load_more = document.querySelector( '.load-more' ),
	      apply_btn = filters.querySelector( '.btn--apply' ),
	      sorting   = filters.querySelector( '.orderby' );

	sorting.addEventListener( 'change', () => apply_btn.click() );

	// Attach filtering
	if ( filters ) {
		const sorting = filters.querySelector( '.orderby' ),
		      price   = [ ...filters.querySelectorAll( '.filter--price .form-control' ) ];


		document.addEventListener( 'click', e => {
			if ( !e.target.matches( '.btn--apply' ) ) return;

			const closest_el  = e.target.closest( '.btn--apply' ),
			      inputs      = filters.querySelectorAll( '.filter input[type="checkbox"]:checked' ),
			      inputValues = getInputCheckValues( inputs ),
			      params      = {
				      parentTax:     filters.dataset.term,
				      parentTaxName: filters.dataset.tax,
				      taxonomy:      [],
				      sorting:       sorting.value,
				      price:         price.map( input => +input.value.replace( '.', '' ).replace( ' RSD', '' ) ).join( '|' ),
			      };

			if ( document.body.classList.contains( 'search' ) ) {
				const load_more_btn = document.querySelector( '.load-more' );

				if ( load_more_btn ) {
					params.per_page = load_more_btn.dataset.per_page || '';
					params.search   = load_more_btn.dataset.search || '';
				}
			}

			// Pack taxonomies
			inputValues.forEach( value => {
				const term = value[ 0 ].split( '-' );

				params[ term[ 0 ] ].push( term[ 1 ] );
				params[ value[ 0 ] ] = value[ 1 ];
			} );

			closest_el.dataset.filters = JSON.stringify( params );

			loadPosts( '/wp-json/custom/filter', composeParameters( params ), 'filter', renderProducts, { output: output, btn: load_more } );
		} );
	}

	// Change number of selected inputs for filter
	document.addEventListener( 'change', e => {
		if ( !e.target.closest( '.filter--checkboxes input' ) ) return;

		const closest_el               = e.target.closest( '.filter--checkboxes input' ),
		      container                = closest_el.closest( '.filter' ),
		      selected_filters_buttons = container.parentElement.querySelector( '.filter--selected' ),
		      selected_filters_num     = container.querySelector( '.selected' ),
		      category_depth           = closest_el.parentElement.dataset.depth.split( '-' ),
		      subcategories            = closest_el.parentElement.querySelectorAll( '.depth-' + category_depth[ 1 ] ),
		      categories_container     = closest_el.closest( '.filter-toggle' );

		if ( closest_el.checked ) {
			// Add buttons indicators for applied filters
			selected_filters_buttons
				.insertAdjacentHTML( 'beforeend', `<button type="button" id="indicator-${ closest_el.id }" data-input="#${ closest_el.id }" class="btn btn--outline btn--indicator">${ closest_el.labels[ 0 ].textContent } &times;</button>` );
			// Show subcategories of the selected category
			subcategories.length && subcategories.forEach( category => category.classList.add( 'show' ) );
		} else {
			// Remove button indicators if input is unchecked
			const button = selected_filters_buttons.querySelector( `#indicator-${ closest_el.id }` );

			button && button.remove();

			// Uncheck also the subcategories
			subcategories.length && subcategories.forEach( category => {
				category.querySelectorAll( 'input:checked' ).forEach( input => {
					input.checked = false;
					new Emmit( input, { type: 'change' } );
				} );
				category.classList.remove( 'show' );
			} );
		}
		// Get checked inputs and display number
		const selected_inputs = container.querySelectorAll( 'input:checked' );

		selected_filters_num.textContent = `(${ selected_inputs.length })`;

		// Change height of the container when hiding/showing subcategories
		new HeightAnim_2( categories_container, categories_container, categories_container.offsetHeight );

		apply_btn.click();
	} );

	// Remove selected filter when clicked and change number of selected filters
	document.addEventListener( 'click', e => {
		if ( !e.target.closest( '.btn--indicator' ) ) return;

		const closest_el = e.target.closest( '.btn--indicator' );
		handleRemoveFilter( closest_el );
	} );

	document.addEventListener( 'click', e => {
		if ( !e.target.closest( '.btn--reset' ) ) return;

		const closest_el        = e.target.closest( '.btn--reset' ),
		      filters_container = closest_el.closest( '.product-filters' ),
		      selected_inputs   = filters_container.querySelectorAll( 'input:checked' ),
		      price_min         = filters_container.querySelector( '#price-min' ),
		      price_max         = filters_container.querySelector( '#price-max' ),
		      sorting           = filters_container.querySelector( '#orderby' );

		selected_inputs.length && selected_inputs.forEach( input => {
			handleRemoveFilter( input, true );
		} );
		price_min && ( price_min.value = 0 );
		price_max && ( price_max.value = price_max.dataset.max );
		if ( sorting ) {
			sorting.value = sorting.options[ 0 ].value;
			new Emmit( sorting, { type: 'change' } );
		}
		apply_btn.click();
	} );

	// Attach load more
	load_more && load_more.addEventListener( 'click', () => {

		const filters = document.querySelector( '[data-filters]' ),
		      params  = filters && JSON.parse( filters.dataset.filters ) || {
			      taxonomy:               'product_cat',
			      'taxonomy-product_cat': load_more.dataset.category
		      };

		params.page = load_more.dataset.page;

		loadPosts( '/wp-json/custom/filter', composeParameters( params ), 'more', renderProductsMore, { output: output, btn: load_more } );
	} );

	// Controlling load animations
	document.addEventListener( 'filter.started', () => document.body.classList.add( 'loading' ) );
	document.addEventListener( 'filter.finished', () => {
		document.body.classList.remove( 'loading' );
		window.scrollTo( {
			                 top:      0,
			                 behavior: 'smooth'
		                 } );
	} );
	document.addEventListener( 'more.started', () => load_more.classList.add( 'loading' ) );
	document.addEventListener( 'more.finished', () => load_more.classList.remove( 'loading' ) );
} );
